
import imgStorageSize_5 from './../../images/success/storage_size_5.png';
import imgStorageSize_10 from './../../images/success/storage_size_10.png';
import imgStorageSize_15 from './../../images/success/storage_size_15.png';
import imgStorageSize_20 from './../../images/success/storage_size_20.png';
import imgStorageSize_25 from './../../images/success/storage_size_25.png';
import imgStorageSize_30 from './../../images/success/storage_size_30.png';
import imgStorageSize_35 from './../../images/success/storage_size_35.png';
import imgStorageSize_40 from './../../images/success/storage_size_40.png';

import imgStorageSize_10c from './../../images/success/10c/1.png';
import imgStorageSize_20c from './../../images/success/10c/2.png';
import imgStorageSize_30c from './../../images/success/10c/3.png';
import imgStorageSize_40c from './../../images/success/10c/4.png';

import imgStorageSize_5_wall from './../../images/success/storage_size_5_wall.png';
import imgStorageSize_10_wall from './../../images/success/storage_size_10_wall.png';
import imgStorageSize_15_wall from './../../images/success/storage_size_15_wall.png';
import imgStorageSize_20_wall from './../../images/success/storage_size_20_wall.png';
import imgStorageSize_25_wall from './../../images/success/storage_size_25_wall.png';
import imgStorageSize_30_wall from './../../images/success/storage_size_30_wall.png';
import imgStorageSize_35_wall from './../../images/success/storage_size_35_wall.png';
import imgStorageSize_40_wall from './../../images/success/storage_size_40_wall.png';

import imgStorageSize_10c_wall from './../../images/success/10c/10C_Products_1.png';
import imgStorageSize_20c_wall from './../../images/success/10c/10C_Products_2.png';
import imgStorageSize_30c_wall from './../../images/success/10c/10C_Products_3.png';
import imgStorageSize_40c_wall from './../../images/success/10c/10C_Products_4.png';

import imgStorageSizeText1c from './../../images/success/10c/10C_Products_1_Labels.png';
import imgStorageSizeText2c from './../../images/success/10c/10C_Products_2_Labels.png';
import imgStorageSizeText3c from './../../images/success/10c/10C_Products_3_Labels.png';
import imgStorageSizeText4c from './../../images/success/10c/10C_Products_4_Labels.png';

import imgStorageSizeText1 from './../../images/success/storage_wall_text_1.png';
import imgStorageSizeText2 from './../../images/success/storage_wall_text_2.png';
import imgStorageSizeText3 from './../../images/success/storage_wall_text_3.png';
import imgStorageSizeText4 from './../../images/success/storage_wall_text_4.png';
import imgStorageSizeText5 from './../../images/success/storage_wall_text_5.png';
import imgStorageSizeText6 from './../../images/success/storage_wall_text_6.png';

import imgSystemSize from './../../images/success/system_size.png';

export const getStorageSizeImageUrl = function (size: number) {
  if (isNaN(size)) return imgStorageSize_5;
  if (process.env.REACT_APP_BATTERY == "5P") {
    if (size <= 5) return imgStorageSize_5;
    else if (size <= 10) return imgStorageSize_10;
    else if (size <= 15) return imgStorageSize_15;
    else if (size <= 20) return imgStorageSize_20;
    else if (size <= 25) return imgStorageSize_25;
    else if (size <= 30) return imgStorageSize_30;
    else if (size <= 35) return imgStorageSize_35;
    else if (size <= 40) return imgStorageSize_40;
    else return imgStorageSize_40;
  }
  else {
    if (isNaN(size)) return imgStorageSize_10c;

    if (size <= 10) return imgStorageSize_10c;
    else if (size <= 20) return imgStorageSize_20c;
    else if (size <= 30) return imgStorageSize_30c;
    else if (size <= 40) return imgStorageSize_40c;
    else return imgStorageSize_40c;
  }
};

export const getStorageSizeWallImageUrls = function (size: number) {

  if (isNaN(size))
    return { imageUrl: imgStorageSize_5_wall, textUrl: imgStorageSizeText1 };
  if (process.env.REACT_APP_BATTERY == "5P") {
    if (size <= 5)
      return { imageUrl: imgStorageSize_5_wall, textUrl: imgStorageSizeText1 };
    else if (size <= 10)
      return { imageUrl: imgStorageSize_10_wall, textUrl: imgStorageSizeText2 };
    else if (size <= 15)
      return { imageUrl: imgStorageSize_15_wall, textUrl: imgStorageSizeText3 };
    else if (size <= 20)
      return { imageUrl: imgStorageSize_20_wall, textUrl: imgStorageSizeText4 };
    else if (size <= 25)
      return { imageUrl: imgStorageSize_25_wall, textUrl: imgStorageSizeText5 };
    else if (size <= 30)
      return { imageUrl: imgStorageSize_30_wall, textUrl: imgStorageSizeText5 };
    else if (size <= 35)
      return { imageUrl: imgStorageSize_35_wall, textUrl: imgStorageSizeText6 };
    else if (size <= 40)
      return { imageUrl: imgStorageSize_40_wall, textUrl: imgStorageSizeText6 };
    else
      return { imageUrl: imgStorageSize_40_wall, textUrl: imgStorageSizeText6 };
  }
  else if (process.env.REACT_APP_BATTERY == "10C") {
    if (isNaN(size))
      return { imageUrl: imgStorageSize_10c_wall, textUrl: imgStorageSizeText1c };

    if (size <= 10)
      return { imageUrl: imgStorageSize_10c_wall, textUrl: imgStorageSizeText1c };
    else if (size <= 20)
      return { imageUrl: imgStorageSize_20c_wall, textUrl: imgStorageSizeText2c };
    else if (size <= 30)
      return { imageUrl: imgStorageSize_30c_wall, textUrl: imgStorageSizeText3c };
    else if (size <= 40)
      return { imageUrl: imgStorageSize_40c_wall, textUrl: imgStorageSizeText4c };
    else
      return { imageUrl: imgStorageSize_40c_wall, textUrl: imgStorageSizeText4c };
  }
  else {
    return { imageUrl: imgStorageSize_5_wall, textUrl: imgStorageSizeText1 };
  }
};

function getBatteryTier(size: number): number {
  if (process.env.REACT_APP_BATTERY == "5P") {
    if (size <= 5) return 5;
    if (size <= 10) return 10;
    if (size <= 15) return 15;
    if (size <= 20) return 20;
    if (size <= 25) return 25;   
    if (size <= 30) return 30;
    if (size <= 35) return 35;
    return 40;
  }
  else {
    if (size <= 10) return 10;
    if (size <= 20) return 20;
    if (size <= 30) return 30;
    return 40;
  }
}


export const getEquipmentData = (calcData: any) => {
  const data = calcData;

  const batterySize = getBatteryTier(data.system_details.battery_size);
  const systemSize =
    Math.round((data.system_details.pv_size_battery + Number.EPSILON) * 100) /
    100;
  const systemSizeText = `${systemSize} kW - ${data.system_details.panel_count} Panels`;

  return {
    solarOnly: {
      header: {
        text: 'Solar only',
        infoBubble: {
          text: 'Solar system size is calculated based on your electricity bill and local electricity tariffs.',
        },
      },
      content: [
        {
          imageUrl: imgSystemSize,
          subtitle: systemSizeText,
          text: 'Solar size',
        },
      ],
      footer: {
        imageUrl: getStorageSizeImageUrl(data.system_details.battery_size),
        imageOpacity: 0,
        subtitle: `${''}`,
        text: '',
      },
    },
    solarAndBattery: {
      header: {
        text: 'Solar & Battery',
        infoBubble: {
          text: 'Solar & Battery configuration is optimized to maximize your electricity bill savings over 25 years.',
          position: 'mobileLeft',
        },
      },
      content: [
        {
          imageUrl: imgSystemSize,
          subtitle: systemSizeText,
          text: 'Solar size',
        },
      ],
      footer: {
        imageUrl: getStorageSizeImageUrl(batterySize),
        subtitle: <div style={{ position: 'relative', top: '7px' }}>{batterySize} kWh</div>,
        text: <div style={{ position: 'relative', top: '6px' }}>Battery size</div>,
      },
    },
  };
};

const formatRegex = /\B(?=(\d{3})+(?!\d))/g;

const getOutOfPocketCost = (
  data: any,
  selectedOption: string,
  type: string
) => {
  const outOfPocket = data[selectedOption][type]?.out_of_pocket;
  return outOfPocket && selectedOption !== 'loan'
    ? `$${Math.round(outOfPocket).toString().replace(formatRegex, ',')}`
    : '$0';
};

const getMonthlyCost = (data: any, selectedOption: string, type: string) => {
  const monthlyCost = data[selectedOption][type].monthly_cost;
  return monthlyCost === 0
    ? 'NA'
    : `$${Math.round(monthlyCost).toString().replace(formatRegex, ',')}`;
};

const getPaybackPeriod = (data: any, selectedOption: string, type: string) => {
  const paybackPeriod = data[selectedOption][type]?.payback_period;
  return paybackPeriod === 0 || selectedOption === 'loan'
    ? 'Immediate'
    : `${paybackPeriod} ${paybackPeriod === 1 ? 'year' : 'years'}`;
};

export const getCostData = (
  data: any,
  selectedOption: string,
  isPDFWidgetVersion?: boolean
) => {
  const result = {
    solarOnly: {
      header: {
        text: 'Solar only',
        infoBubble: {
          text: 'Solar system size is calculated based on your electricity bill and local electricity tariffs.',
        },
      },
      content: [
        isPDFWidgetVersion
          ? null
          : {
            subtitle: getOutOfPocketCost(data, selectedOption, 'solar'),
            text: 'Out-of-pocket cost',
          },
        selectedOption === 'loan'
          ? null
          : {
            subtitle: getPaybackPeriod(data, selectedOption, 'solar'),
            text: 'Payback period',
            infoBubble: {
              text: 'Number of years it will take to recover initial investment after adjusting for federal tax incentive',
            },
          },
      ],
      footer:
        selectedOption === 'loan'
          ? {
            subtitle: getMonthlyCost(data, selectedOption, 'solar') + '*',
            text: 'Monthly payment',
          }
          : null,
    },
    solarAndBattery: {
      header: {
        text: 'Solar & Battery',
        infoBubble: {
          text: 'Solar & Battery configuration is optimized to maximize your electricity bill savings over 25 years.',
          position: 'mobileLeft',
        },
      },
      content: [
        isPDFWidgetVersion
          ? null
          : {
            subtitle: getOutOfPocketCost(
              data,
              selectedOption,
              'solar_battery'
            ),
            text: 'Out-of-pocket cost',
          },
        selectedOption === 'loan'
          ? null
          : {
            subtitle: getPaybackPeriod(data, selectedOption, 'solar_battery'),
            text: 'Payback period',
            infoBubble: {
              text: 'Number of years it will take to recover initial investment after adjusting for federal tax incentive',
              position: 'mobileLeft',
            },
          },
      ],
      footer:
        selectedOption === 'loan'
          ? {
            subtitle:
              getMonthlyCost(data, selectedOption, 'solar_battery') + '*',
            text: 'Monthly payment',
          }
          : null,
    },
  };

  return result;
};

const getFederalIncentive = (
  data: any,
  selectedOption: string,
  type: string
) => {
  let itc = 0;
  if (data[selectedOption]) {
    itc = data[selectedOption][type]?.itc;
  }
  return `$${Math.round(itc).toString().replace(formatRegex, ',')}`;
};

const getNetSavings = (data: any, selectedOption: string, type: string) => {
  let netSavings = 0;
  if (data[selectedOption][type]) {
    netSavings = data[selectedOption][type]['savings25Years'];
  }
  return `$${Math.round(netSavings).toString().replace(formatRegex, ',')}`;
};

const getCostAfterIncentive = (
  data: any,
  selectedOption: string,
  type: string
) => {
  let costAfterIncentives = 0;
  if (data[selectedOption][type]) {
    costAfterIncentives = Math.round(
      data[selectedOption][type].system_cost - data[selectedOption][type].itc
    );
  }
  return `$${Math.round(costAfterIncentives)
    .toString()
    .replace(formatRegex, ',')}`;
};

export const getSavingsAndIncentiveData = (
  data: any,
  selectedOption: string
) => {
  const savings = {
    solarOnly: {
      content: [
        {
          subtitle: getNetSavings(data, selectedOption, 'solar'),
          text: '25 year net savings',
        },
      ],
      footer: null,
    },
    solarAndBattery: {
      content: [
        {
          subtitle: getNetSavings(data, selectedOption, 'solar_battery'),
          text: '25 year net savings',
        },
      ],
      footer: null,
    },
  };

  if (selectedOption === 'cash') {
    savings.solarOnly.content.unshift({
      subtitle: getCostAfterIncentive(data, selectedOption, 'solar'),
      text: 'Total cost after incentives',
    });
    // savings.solarOnly.content.unshift({
    //   subtitle: getFederalIncentive(data, selectedOption, 'solar'),
    //   text: 'Federal incentive',
    // });
    savings.solarAndBattery.content.unshift({
      subtitle: getCostAfterIncentive(data, selectedOption, 'solar_battery'),
      text: 'Total cost after incentives',
    });
    // savings.solarAndBattery.content.unshift({
    //   subtitle: getFederalIncentive(data, selectedOption, 'solar_battery'),
    //   text: 'Federal incentive',
    // });
  }

  return savings;
};

export const getSavingsAndIncentiveDataNoCost = (
  data: any,
  selectedOption: string,
  isDebrandedVersionVersion?: false

) => {
  const savings: any = {
    solarOnly: {
      content: [
        {
          subtitle: getNetSavings(data, selectedOption, 'solar'),
          text: '25 year net savings',
        },
      ],
      footer: null,
    },
    solarAndBattery: {
      content: [
        {
          subtitle: getNetSavings(data, selectedOption, 'solar_battery'),
          text: '25 year net savings',
        },
      ],
      footer: null,
    },
  };

  if (selectedOption === 'cash') {
    savings.solarOnly.content.push({
      subtitle: getPaybackPeriod(data, selectedOption, 'solar'),
      text: 'Payback period',
      infoBubble: isDebrandedVersionVersion
        ? null
        : {
          text: 'Number of years it will take to recover initial investment after adjusting for federal tax incentive',
        },
    });
    // savings.solarOnly.content.push({
    //   subtitle: getFederalIncentive(data, selectedOption, 'solar'),
    //   text: 'Federal incentive',
    // });
    savings.solarAndBattery.content.push({
      subtitle: getPaybackPeriod(data, selectedOption, 'solar_battery'),
      text: 'Payback period',
      infoBubble: isDebrandedVersionVersion
        ? null
        : {
          text: 'Number of years it will take to recover initial investment after adjusting for federal tax incentive',
          position: 'mobileLeft',
        },
    });
    // savings.solarAndBattery.content.push({
    //   subtitle: getFederalIncentive(data, selectedOption, 'solar_battery'),
    //   text: 'Federal incentive',
    // });
  }

  return savings;
};

export const getSavingsAndIncentiveDataNoCostPDF = (
  data: any,
  selectedOption: string
) => {
  const savings = getSavingsAndIncentiveDataNoCost(data, selectedOption);
  savings.solarOnly.header = {
    text: 'Solar Only',
  };
  savings.solarAndBattery.header = {
    text: 'Solar & Battery',
  };
  return savings;
};

export const h1Class =
  'text-black text-[32px] md:text-[56px] leading-tight text-center';
export const h2Class =
  'text-black text-[18px] md:text-[42px] leading-tight text-center';
export const h2ClassLg =
  'text-black text-[22px] md:text-[42px] leading-tight text-center';
export const h3Class = 'text-black text-[22px] md:text-[32px] leading-tight';
export const h4Class = 'text-black text-[22px] md:text-[24px] leading-tight';
export const h5Class = 'text-black text-[14px] md:text-[24px] leading-tight';
export const smFontClass = 'text-black text-[10px] md:text-[17px]';
export const listClass = 'list-disc ml-[2rem]';
